import { useContext, useEffect, useState } from "react";
import CategorySelection from "./LUPages/CategorySelection";
import CategoryDisplay from "./LUPages/CategoryDisplay";
import { GlobalContext } from "../../common/Context";
import ConditionalDisplay from "../../common/ConditionalDisplay";
import { useSessionState } from "../../common/Utils/useSessionState";
import { useTranslation } from "react-i18next";

const initialCatObj = {
  id: null,
  name: "",
  title: "",
  desc: "",
  subCat: [],
};

const LevelUp = () => {
  const { t } = useTranslation(["LevelUp", "ScoreCategories"]);
  const { optionState, userState, firebaseState } = useContext(GlobalContext);

  const [objState, setObjState] = useSessionState("objState", initialCatObj);
  const [watchList, setWatchList] = useState([]);

  useEffect(() => {
    try {
      const getUser = async () => {
        setWatchList(
          await firebaseState.getWatchListByUserId(userState.profileID),
        );
      };
      userState.profileID && getUser();
    } catch (e) {
      console.error(e.message);
    }
  }, [firebaseState, userState]);

  useEffect(() => {
    if (optionState.selSubCat) {
      const newObjState = t("ScoreCategories:categories").find((cat) => {
        return cat.subCat.some((subcat) => {
          return (
            subcat.name.toLowerCase() === optionState.selSubCat.toLowerCase()
          );
        });
      });
      setObjState(newObjState || initialCatObj);
    }
  }, [optionState.selSubCat, setObjState, t]);

  return (
    <>
      <ConditionalDisplay
        display={optionState.nav === "levelUp" && optionState.page === "main"}>
        <CategorySelection setObjState={setObjState} />
      </ConditionalDisplay>
      <ConditionalDisplay
        unmount
        display={
          optionState.nav === "levelUp" && optionState.page === "display"
        }>
        <CategoryDisplay objState={objState} watchList={watchList} />
      </ConditionalDisplay>
    </>
  );
};

export default LevelUp;
